var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlockchain(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1966.3 1123.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        opacity: .27;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73, .cls-74, .cls-75, .cls-76, .cls-77, .cls-78, .cls-79, .cls-80, .cls-81, .cls-82, .cls-83, .cls-84, .cls-85, .cls-86, .cls-87, .cls-88, .cls-89, .cls-90, .cls-91, .cls-92, .cls-93, .cls-94, .cls-95, .cls-96, .cls-97, .cls-98, .cls-99, .cls-100, .cls-101, .cls-102, .cls-103, .cls-104, .cls-105, .cls-106, .cls-107, .cls-108, .cls-109, .cls-110, .cls-111, .cls-112, .cls-113, .cls-114, .cls-115, .cls-116, .cls-117, .cls-118, .cls-119, .cls-120, .cls-121, .cls-122, .cls-123, .cls-124, .cls-125, .cls-126, .cls-127, .cls-128, .cls-129, .cls-130, .cls-131, .cls-132, .cls-133, .cls-134, .cls-135, .cls-136, .cls-137 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-7, .cls-9, .cls-12, .cls-15, .cls-20, .cls-22, .cls-27, .cls-28, .cls-29, .cls-31, .cls-35, .cls-37, .cls-39, .cls-40, .cls-43, .cls-47, .cls-50, .cls-52, .cls-61, .cls-63, .cls-70, .cls-72, .cls-74, .cls-77, .cls-80, .cls-84, .cls-86, .cls-87, .cls-88, .cls-91, .cls-95, .cls-98, .cls-105, .cls-109, .cls-112, .cls-114, .cls-116, .cls-118, .cls-119, .cls-123, .cls-125, .cls-128, .cls-132, .cls-133, .cls-134, .cls-135, .cls-136, .cls-137 {\r\n        fill: #a7b1f2;\r\n      }\r\n\r\n      .cls-2 {\r\n        opacity: .86;\r\n      }\r\n\r\n      .cls-3 {\r\n        opacity: .52;\r\n      }\r\n\r\n      .cls-4 {\r\n        opacity: .57;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-38);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-12);\r\n      }\r\n\r\n      .cls-7 {\r\n        opacity: .14;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #8a96e6;\r\n      }\r\n\r\n      .cls-9 {\r\n        opacity: .19;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#linear-gradient-17);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: #e3e5f9;\r\n      }\r\n\r\n      .cls-12 {\r\n        opacity: .1;\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: url(#linear-gradient-19);\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: url(#linear-gradient-33);\r\n      }\r\n\r\n      .cls-15 {\r\n        opacity: .48;\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: #4361ff;\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: url(#linear-gradient-62);\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: #42c8ff;\r\n      }\r\n\r\n      .cls-20 {\r\n        opacity: .24;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: url(#linear-gradient-57);\r\n      }\r\n\r\n      .cls-22 {\r\n        opacity: .81;\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: url(#linear-gradient-21);\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: #a5b6f5;\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: #ccd2ff;\r\n      }\r\n\r\n      .cls-27 {\r\n        opacity: .33;\r\n      }\r\n\r\n      .cls-28 {\r\n        opacity: .76;\r\n      }\r\n\r\n      .cls-29 {\r\n        opacity: .86;\r\n      }\r\n\r\n      .cls-138 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: url(#linear-gradient-42);\r\n      }\r\n\r\n      .cls-31 {\r\n        opacity: .82;\r\n      }\r\n\r\n      .cls-32 {\r\n        fill: url(#linear-gradient-15);\r\n      }\r\n\r\n      .cls-33 {\r\n        fill: url(#linear-gradient-44);\r\n      }\r\n\r\n      .cls-33, .cls-139 {\r\n        mix-blend-mode: multiply;\r\n      }\r\n\r\n      .cls-34 {\r\n        fill: url(#linear-gradient-11);\r\n      }\r\n\r\n      .cls-35 {\r\n        opacity: .09;\r\n      }\r\n\r\n      .cls-36 {\r\n        fill: #f2f5ff;\r\n      }\r\n\r\n      .cls-37 {\r\n        opacity: .38;\r\n      }\r\n\r\n      .cls-38 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-39 {\r\n        opacity: .43;\r\n      }\r\n\r\n      .cls-40 {\r\n        opacity: .76;\r\n      }\r\n\r\n      .cls-41 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-42 {\r\n        fill: url(#linear-gradient-31);\r\n      }\r\n\r\n      .cls-43 {\r\n        opacity: .64;\r\n      }\r\n\r\n      .cls-44 {\r\n        fill: url(#linear-gradient-58);\r\n      }\r\n\r\n      .cls-45 {\r\n        fill: url(#linear-gradient-63);\r\n      }\r\n\r\n      .cls-46 {\r\n        fill: url(#linear-gradient-34);\r\n      }\r\n\r\n      .cls-47 {\r\n        opacity: .67;\r\n      }\r\n\r\n      .cls-48 {\r\n        fill: url(#linear-gradient-41);\r\n      }\r\n\r\n      .cls-49 {\r\n        fill: #f3abc7;\r\n      }\r\n\r\n      .cls-50 {\r\n        opacity: .29;\r\n      }\r\n\r\n      .cls-51 {\r\n        fill: url(#linear-gradient-40);\r\n      }\r\n\r\n      .cls-52 {\r\n        opacity: .19;\r\n      }\r\n\r\n      .cls-53 {\r\n        fill: url(#linear-gradient-13);\r\n      }\r\n\r\n      .cls-54 {\r\n        fill: url(#linear-gradient-23);\r\n      }\r\n\r\n      .cls-55 {\r\n        fill: url(#linear-gradient-25);\r\n      }\r\n\r\n      .cls-56 {\r\n        fill: url(#linear-gradient-43);\r\n      }\r\n\r\n      .cls-57 {\r\n        fill: #d2d6f2;\r\n      }\r\n\r\n      .cls-58 {\r\n        fill: url(#linear-gradient-16);\r\n      }\r\n\r\n      .cls-59 {\r\n        fill: url(#linear-gradient-22);\r\n      }\r\n\r\n      .cls-60 {\r\n        fill: url(#linear-gradient-54);\r\n      }\r\n\r\n      .cls-61 {\r\n        opacity: .67;\r\n      }\r\n\r\n      .cls-62 {\r\n        fill: url(#linear-gradient-55);\r\n      }\r\n\r\n      .cls-63 {\r\n        opacity: .73;\r\n      }\r\n\r\n      .cls-64 {\r\n        fill: url(#linear-gradient-35);\r\n      }\r\n\r\n      .cls-65 {\r\n        fill: url(#linear-gradient-50);\r\n      }\r\n\r\n      .cls-66 {\r\n        fill: url(#linear-gradient-32);\r\n      }\r\n\r\n      .cls-67 {\r\n        fill: url(#linear-gradient-60);\r\n      }\r\n\r\n      .cls-68 {\r\n        fill: url(#linear-gradient-59);\r\n      }\r\n\r\n      .cls-69 {\r\n        fill: url(#linear-gradient-20);\r\n      }\r\n\r\n      .cls-70 {\r\n        opacity: .57;\r\n      }\r\n\r\n      .cls-71 {\r\n        fill: url(#linear-gradient-14);\r\n      }\r\n\r\n      .cls-72 {\r\n        opacity: .1;\r\n      }\r\n\r\n      .cls-73 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-74 {\r\n        opacity: 0;\r\n      }\r\n\r\n      .cls-75 {\r\n        fill: #e6ebff;\r\n      }\r\n\r\n      .cls-76 {\r\n        fill: url(#linear-gradient-52);\r\n      }\r\n\r\n      .cls-77 {\r\n        opacity: .9;\r\n      }\r\n\r\n      .cls-78 {\r\n        fill: url(#linear-gradient-45);\r\n      }\r\n\r\n      .cls-79 {\r\n        fill: #ced7ff;\r\n      }\r\n\r\n      .cls-80 {\r\n        opacity: .45;\r\n      }\r\n\r\n      .cls-81 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-82 {\r\n        fill: url(#linear-gradient-39);\r\n      }\r\n\r\n      .cls-83 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-84 {\r\n        opacity: .95;\r\n      }\r\n\r\n      .cls-85 {\r\n        fill: #42eaff;\r\n      }\r\n\r\n      .cls-86 {\r\n        opacity: .55;\r\n      }\r\n\r\n      .cls-140 {\r\n        clip-path: url(#clippath);\r\n      }\r\n\r\n      .cls-87 {\r\n        opacity: .9;\r\n      }\r\n\r\n      .cls-88 {\r\n        opacity: .05;\r\n      }\r\n\r\n      .cls-89 {\r\n        fill: url(#linear-gradient-9);\r\n      }\r\n\r\n      .cls-90 {\r\n        fill: url(#linear-gradient-27);\r\n      }\r\n\r\n      .cls-91 {\r\n        opacity: .81;\r\n      }\r\n\r\n      .cls-92 {\r\n        fill: url(#linear-gradient-53);\r\n      }\r\n\r\n      .cls-93 {\r\n        fill: #42ddff;\r\n      }\r\n\r\n      .cls-94 {\r\n        fill: url(#linear-gradient-36);\r\n      }\r\n\r\n      .cls-95 {\r\n        opacity: .91;\r\n      }\r\n\r\n      .cls-96 {\r\n        fill: url(#linear-gradient-48);\r\n      }\r\n\r\n      .cls-97 {\r\n        fill: url(#linear-gradient-49);\r\n      }\r\n\r\n      .cls-98 {\r\n        opacity: .62;\r\n      }\r\n\r\n      .cls-99 {\r\n        fill: #2cf0ff;\r\n      }\r\n\r\n      .cls-100 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n\r\n      .cls-101 {\r\n        fill: url(#linear-gradient-47);\r\n      }\r\n\r\n      .cls-102 {\r\n        fill: url(#linear-gradient-24);\r\n      }\r\n\r\n      .cls-103 {\r\n        fill: url(#linear-gradient-26);\r\n      }\r\n\r\n      .cls-104 {\r\n        fill: url(#linear-gradient-61);\r\n      }\r\n\r\n      .cls-105 {\r\n        opacity: .38;\r\n      }\r\n\r\n      .cls-106 {\r\n        fill: url(#linear-gradient-18);\r\n      }\r\n\r\n      .cls-107 {\r\n        fill: url(#linear-gradient-51);\r\n      }\r\n\r\n      .cls-108 {\r\n        fill: #32b4ff;\r\n      }\r\n\r\n      .cls-109 {\r\n        opacity: .95;\r\n      }\r\n\r\n      .cls-110 {\r\n        fill: url(#linear-gradient-30);\r\n      }\r\n\r\n      .cls-111 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-112 {\r\n        opacity: .33;\r\n      }\r\n\r\n      .cls-113 {\r\n        fill: url(#linear-gradient-29);\r\n      }\r\n\r\n      .cls-114 {\r\n        opacity: .52;\r\n      }\r\n\r\n      .cls-115 {\r\n        fill: url(#linear-gradient-46);\r\n      }\r\n\r\n      .cls-116 {\r\n        opacity: .18;\r\n      }\r\n\r\n      .cls-117 {\r\n        fill: url(#linear-gradient-64);\r\n      }\r\n\r\n      .cls-119 {\r\n        opacity: .43;\r\n      }\r\n\r\n      .cls-120 {\r\n        fill: url(#linear-gradient-28);\r\n      }\r\n\r\n      .cls-121 {\r\n        fill: url(#linear-gradient-56);\r\n      }\r\n\r\n      .cls-122 {\r\n        fill: url(#linear-gradient-10);\r\n      }\r\n\r\n      .cls-123 {\r\n        opacity: .36;\r\n      }\r\n\r\n      .cls-124 {\r\n        fill: #bcc9f8;\r\n      }\r\n\r\n      .cls-125 {\r\n        opacity: .71;\r\n      }\r\n\r\n      .cls-126 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-127 {\r\n        fill: #bccaf8;\r\n      }\r\n\r\n      .cls-128 {\r\n        opacity: .05;\r\n      }\r\n\r\n      .cls-129 {\r\n        fill: url(#linear-gradient-37);\r\n      }\r\n\r\n      .cls-130 {\r\n        fill: #5b78e6;\r\n      }\r\n\r\n      .cls-131 {\r\n        fill: #f7f9ff;\r\n      }\r\n\r\n      .cls-132 {\r\n        opacity: .48;\r\n      }\r\n\r\n      .cls-133 {\r\n        opacity: .24;\r\n      }\r\n\r\n      .cls-134 {\r\n        opacity: .62;\r\n      }\r\n\r\n      .cls-135 {\r\n        opacity: .29;\r\n      }\r\n\r\n      .cls-136 {\r\n        opacity: .14;\r\n      }\r\n\r\n      .cls-137 {\r\n        opacity: .71;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1334.79,
    y1: 84.03,
    x2: 1623.74,
    y2: 84.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8eafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1479.26,
    y1: 84.03,
    x2: 1551.5,
    y2: 84.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9defc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccd6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1515.38,
    y1: 192.4,
    x2: 1587.62,
    y2: 192.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1334.79,
    y1: 192.4,
    x2: 1479.26,
    y2: 192.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1515.38,
    y1: 210.46,
    x2: 1587.62,
    y2: 210.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1370.91,
    y1: 210.46,
    x2: 1443.14,
    y2: 210.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 748.71,
    y1: 418.25,
    x2: 992.23,
    y2: 418.25,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 748.71,
    y1: 235.61,
    x2: 1235.74,
    y2: 235.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8eafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1022.67,
    y1: 631.35,
    x2: 1205.3,
    y2: 448.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92a6f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f93e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1205.29,
    y1: 692.24,
    x2: 1509.71,
    y2: 387.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92a6f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aab9f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 992.23,
    y1: 357.39,
    x2: 1479.26,
    y2: 357.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aab9f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccd6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 505.19,
    y1: 540.03,
    x2: 748.71,
    y2: 540.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 505.19,
    y1: 357.39,
    x2: 992.23,
    y2: 357.39,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 748.71,
    y1: 661.82,
    x2: 992.23,
    y2: 661.82,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    y1: 479.18,
    y2: 479.18,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 850.83,
    y1: 150.72,
    x2: 1136.2,
    y2: 150.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3d7f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#bbc9f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#d3d7f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 2916.11,
    y1: -425.23,
    x2: 3073.35,
    y2: -425.23,
    gradientTransform: "translate(-1575.99 1782.42) rotate(-26.57) scale(1.12 .89) skewX(30.96)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 923.72,
    y1: 72.1,
    x2: 1063.79,
    y2: 72.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6697ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e69ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1047.7,
    y1: 44.6,
    x2: 937.75,
    y2: 100.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#174dba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7023ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 208.71,
    y1: 180.7,
    x2: 328.74,
    y2: 416.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edeefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fcfcfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#dde2fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1e3f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 123.84,
    y1: 328.63,
    x2: 290.21,
    y2: 328.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 743.16,
    y1: 280.31,
    x2: 607.82,
    y2: 348.66,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 898.83,
    y1: 350.38,
    x2: 752.56,
    y2: 282.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7023ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 605.88,
    y1: 205.55,
    x2: 896.56,
    y2: 205.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#646eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42c0ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 676.4,
    y1: 205.55,
    x2: 821.02,
    y2: 205.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 734.86,
    y1: 215.54,
    x2: 801.73,
    y2: 178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9ecfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#d2dafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbc9f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 654.8,
    y1: 326.15,
    x2: 696.58,
    y2: 302.69,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1230.19,
    y1: 280.31,
    x2: 1094.85,
    y2: 348.66,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1385.87,
    x2: 1239.59,
    y2: 282.03,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1144.23,
    y1: 324.8,
    x2: 1181.38,
    y2: 303.95,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1092.91,
    x2: 1383.59,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 117.39,
    y1: 707.35,
    x2: 319.84,
    y2: 707.35,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 117.39,
    y1: 815.57,
    x2: 261.67,
    y2: 815.57,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 175.55,
    y1: 808.01,
    x2: 405.96,
    y2: 808.01,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 285.26,
    y1: 743.77,
    x2: 336.21,
    y2: 743.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 355.01,
    y1: 743.77,
    x2: 405.96,
    y2: 743.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 319.03,
    y1: 761.76,
    x2: 369.98,
    y2: 761.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 319.03,
    y1: 690.09,
    x2: 369.98,
    y2: 690.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 285.26,
    y1: 707.94,
    x2: 336.21,
    y2: 707.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 355.01,
    y1: 707.94,
    x2: 405.96,
    y2: 707.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 319.03,
    y1: 725.93,
    x2: 369.98,
    y2: 725.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 847.27,
    y1: 449.73,
    x2: 1137.14,
    y2: 449.73,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 845.77,
    y1: 428.42,
    x2: 1138.63,
    y2: 428.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 990.15,
    y1: 445.6,
    x2: 847.54,
    y2: 445.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbe4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 871.61,
    y1: 406.78,
    x2: 1118.81,
    y2: 406.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#427dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#7023ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#174dba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#4785ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#427dff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 871.61,
    y1: 391.93,
    x2: 1118.81,
    y2: 391.93,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 896.4,
    y1: 391.93,
    x2: 1093.15,
    y2: 391.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42c0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42ffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    y1: 356.27,
    y2: 356.27,
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 871.61,
    y1: 341.43,
    x2: 1118.81,
    y2: 341.43,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    y1: 341.43,
    y2: 341.43,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    y1: 305.77,
    y2: 305.77,
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 871.61,
    y1: 290.92,
    x2: 1118.81,
    y2: 290.92,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 903.99,
    y1: 290.92,
    x2: 1084.25,
    y2: 290.92,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 929.89,
    y1: 290.92,
    x2: 1058.48,
    y2: 290.92,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 1821.75,
    y1: 982.41,
    x2: 1447.14,
    y2: 807.36,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -2460.25,
    y1: 814.4,
    x2: -1972.29,
    y2: 814.4,
    gradientTransform: "translate(-605.42) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1519.75,
    y1: 711.89,
    x2: 1640.28,
    y2: 711.89,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1583.16,
    y1: 768.61,
    x2: 1583.16,
    y2: 696.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1529.15,
    y1: 713.25,
    x2: 1639.07,
    y2: 713.25,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -1985.36,
    y1: 937.69,
    x2: -2156.9,
    y2: 1024.33,
    gradientTransform: "translate(3534.52 1960.85) scale(1 -1)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1692.14,
    y1: 778.48,
    x2: 1580.46,
    y2: 834.89,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -2302.38,
    y1: 803.55,
    x2: -2182.58,
    y2: 803.55,
    gradientTransform: "translate(-605.42) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1611.41,
    y1: 1010.88,
    x2: 1761.91,
    y2: 1010.88,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 1611.41,
    y1: 944.14,
    x2: 1912.42,
    y2: 944.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "1611.58 937.56 1668.77 908.21 1802.4 915.39 1843.26 769.18 1761.91 706.4 1593.23 706.4 1593.23 897.51 1611.58 937.56"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "1479.26 844.48 1235.74 722.7 1479.26 600.91 1722.78 722.7 1479.26 844.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "261.67 479.13 18.16 357.34 261.67 235.56 505.19 357.34 261.67 479.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "1235.74 966.27 992.23 844.48 1235.74 722.7 1479.26 844.48 1235.74 966.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "1722.78 966.27 1479.26 844.48 1722.78 722.7 1966.3 844.48 1722.78 966.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "1479.26 1088.05 1235.74 966.27 1479.26 844.48 1722.78 966.27 1479.26 1088.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "505.19 357.34 261.67 235.56 505.19 113.77 748.71 235.56 505.19 357.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "748.71 479.13 505.19 357.34 748.71 235.56 992.23 357.34 748.71 479.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "505.19 600.91 261.67 479.13 505.19 357.34 748.71 479.13 505.19 600.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "505.19 844.48 261.67 722.7 505.19 600.91 748.71 722.7 505.19 844.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "261.67 966.27 18.16 844.48 261.67 722.7 505.19 844.48 261.67 966.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "748.71 966.27 505.19 844.48 748.71 722.7 992.23 844.48 748.71 966.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "505.19 1088.05 261.67 966.27 505.19 844.48 748.71 966.27 505.19 1088.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "1479.26 357.34 1235.74 235.56 1479.26 113.77 1722.78 235.56 1479.26 357.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "1235.74 479.13 992.23 357.34 1235.74 235.56 1479.26 357.34 1235.74 479.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "1722.78 479.13 1479.26 357.34 1722.78 235.56 1966.3 357.34 1722.78 479.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "1479.26 600.91 1235.74 479.13 1479.26 357.34 1722.78 479.13 1479.26 600.91"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "1362.25 214.77 1506.72 287.03 1362.25 359.28 1217.77 287.03 1362.25 214.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "1372.89 209.45 1517.36 281.71 1372.89 353.96 1228.41 281.71 1372.89 209.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "1383.52 204.13 1528 276.39 1383.52 348.64 1239.05 276.39 1383.52 204.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1394.16 198.82 1538.64 271.07 1394.16 343.32 1249.69 271.07 1394.16 198.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "1404.8 193.5 1549.27 265.75 1404.8 338 1260.32 265.75 1404.8 193.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "1415.44 188.18 1559.91 260.43 1415.44 332.68 1270.96 260.43 1415.44 188.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "1426.07 182.86 1570.55 255.11 1426.07 327.36 1281.6 255.11 1426.07 182.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "1436.71 177.54 1581.19 249.79 1436.71 322.04 1292.24 249.79 1436.71 177.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "1447.35 172.22 1591.82 244.47 1447.35 316.72 1302.87 244.47 1447.35 172.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "1457.99 166.9 1602.46 239.15 1457.99 311.4 1313.51 239.15 1457.99 166.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "1468.62 161.58 1613.1 233.83 1468.62 306.08 1324.15 233.83 1468.62 161.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "1479.26 156.26 1623.74 228.51 1479.26 300.76 1334.79 228.51 1479.26 156.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1623.74 84.03 1479.26 156.29 1334.79 84.03 1479.26 11.78 1623.74 84.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1551.5 84.03 1479.26 120.16 1407.02 84.03 1479.26 47.91 1551.5 84.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "1551.5 84.03 1479.26 120.16 1479.26 47.91 1551.5 84.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1623.74 228.51 1479.26 300.76 1479.26 156.29 1623.74 84.03 1623.74 228.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "1587.62 210.45 1515.38 246.58 1515.38 174.34 1587.62 138.22 1587.62 210.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "1479.26 300.76 1334.79 228.51 1334.79 84.03 1479.26 156.29 1479.26 300.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1443.14 246.58 1370.91 210.45 1370.91 138.22 1443.14 174.34 1443.14 246.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "1587.62 210.45 1515.38 246.58 1515.38 174.34 1587.62 210.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "1443.14 246.58 1370.91 210.45 1443.14 174.34 1443.14 246.58"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "1551.5 58.23 1479.26 94.36 1407.02 58.23 1479.26 22.11 1551.5 58.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1551.5 84.03 1479.26 120.16 1479.26 94.36 1551.5 58.23 1551.5 84.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "1479.26 120.16 1407.02 84.03 1407.02 58.23 1479.26 94.36 1479.26 120.16"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "881.7 413.56 1367.79 656.66 881.7 899.76 395.6 656.66 881.7 413.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "891.74 408.54 1377.84 651.63 891.74 894.73 405.65 651.63 891.74 408.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "901.79 403.51 1387.89 646.61 901.79 889.71 415.7 646.61 901.79 403.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "911.84 398.49 1397.93 641.58 911.84 884.68 425.75 641.58 911.84 398.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "921.89 393.46 1407.98 636.56 921.89 879.66 435.8 636.56 921.89 393.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "931.94 388.44 1418.03 631.53 931.94 874.63 445.84 631.53 931.94 388.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "941.99 383.41 1428.08 626.51 941.99 869.61 455.89 626.51 941.99 383.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "952.03 378.39 1438.13 621.48 952.03 864.58 465.94 621.48 952.03 378.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "962.08 373.36 1448.17 616.46 962.08 859.56 475.99 616.46 962.08 373.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "972.13 368.33 1458.22 611.43 972.13 854.53 486.04 611.43 972.13 368.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "982.18 363.31 1468.27 606.41 982.18 849.51 496.09 606.41 982.18 363.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "992.23 358.28 1478.32 601.38 992.23 844.48 506.13 601.38 992.23 358.28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "992.23 600.91 748.71 479.13 748.71 235.58 992.23 357.37 992.23 600.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "992.23 600.91 1235.74 479.13 1235.74 235.58 992.23 357.37 992.23 600.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "992.23 357.39 748.71 235.61 992.23 113.82 1235.74 235.61 992.23 357.39"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1235.74 722.7 992.23 600.91 992.23 357.37 1235.74 479.15 1235.74 722.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "1235.74 722.7 1479.26 600.91 1479.26 357.37 1235.74 479.15 1235.74 722.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "1235.74 479.18 992.23 357.39 1235.74 235.61 1479.26 357.39 1235.74 479.18"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M1422.09,537.44l-129.17,64.6c-5.37,2.68-9.72.51-9.72-4.86s4.35-11.89,9.72-14.58l129.17-64.6c5.37-2.68,9.72-.51,9.72,4.86s-4.35,11.89-9.72,14.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M1333.9,569.32l-40.54,20.27c-1.38.69-2.5,2.37-2.5,3.75s1.12,1.94,2.5,1.25l40.54-20.27c1.38-.69,2.5-2.37,2.5-3.75s-1.12-1.94-2.5-1.25ZM1392.42,540.05l-16.39,8.2c-1.38.69-2.5,2.37-2.5,3.75s1.12,1.94,2.5,1.25l16.39-8.2c1.38-.69,2.5-2.37,2.5-3.75s-1.12-1.94-2.5-1.25ZM1421.64,525.44l-16.39,8.2c-1.38.69-2.5,2.37-2.5,3.75s1.12,1.94,2.5,1.25l16.39-8.2c1.38-.69,2.5-2.37,2.5-3.75s-1.12-1.94-2.5-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M1422.09,565.19l-129.17,64.6c-5.37,2.68-9.72.51-9.72-4.86s4.35-11.89,9.72-14.58l129.17-64.6c5.37-2.68,9.72-.51,9.72,4.86s-4.35,11.89-9.72,14.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M1333.9,597.08l-40.54,20.27c-1.38.69-2.5,2.37-2.5,3.75s1.12,1.94,2.5,1.25l40.54-20.27c1.38-.69,2.5-2.37,2.5-3.75s-1.12-1.94-2.5-1.25ZM1392.42,567.81l-16.39,8.2c-1.38.69-2.5,2.37-2.5,3.75s1.12,1.94,2.5,1.25l16.39-8.2c1.38-.69,2.5-2.37,2.5-3.75s-1.12-1.94-2.5-1.25ZM1421.64,553.2l-16.39,8.2c-1.38.69-2.5,2.37-2.5,3.75s1.12,1.94,2.5,1.25l16.39-8.2c1.38-.69,2.5-2.37,2.5-3.75s-1.12-1.94-2.5-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M1422.09,592.95l-129.17,64.6c-5.37,2.68-9.72.51-9.72-4.86s4.35-11.89,9.72-14.58l129.17-64.6c5.37-2.68,9.72-.51,9.72,4.86s-4.35,11.89-9.72,14.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M1333.9,624.83l-40.54,20.27c-1.38.69-2.5,2.37-2.5,3.75s1.12,1.94,2.5,1.25l40.54-20.27c1.38-.69,2.5-2.37,2.5-3.75s-1.12-1.94-2.5-1.25ZM1392.42,595.57l-16.39,8.2c-1.38.69-2.5,2.37-2.5,3.75s1.12,1.94,2.5,1.25l16.39-8.2c1.38-.69,2.5-2.37,2.5-3.75s-1.12-1.94-2.5-1.25ZM1421.64,580.95l-16.39,8.2c-1.38.69-2.5,2.37-2.5,3.75s1.12,1.94,2.5,1.25l16.39-8.2c1.38-.69,2.5-2.37,2.5-3.75s-1.12-1.94-2.5-1.25Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "748.71 722.7 505.19 600.91 505.19 357.37 748.71 479.15 748.71 722.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M676.69,601.87l-99.47-49.75c-4.65-2.33-8.42-7.98-8.42-12.63v-57.1c0-4.65,3.77-6.53,8.42-4.21l99.47,49.75c4.65,2.32,8.42,7.98,8.42,12.63v57.1c0,4.65-3.77,6.53-8.42,4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M683.76,598.33l-99.47-49.75c-4.65-2.32-8.42-7.98-8.42-12.63v-57.1c0-.42.04-.81.1-1.19-4.06-1.43-7.18.5-7.18,4.73v57.1c0,4.65,3.77,10.3,8.42,12.63l99.47,49.75c4.23,2.11,7.72.74,8.32-3.02-.41-.14-.82-.31-1.24-.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "684.66 571.54 668.11 563.26 661.12 545.79 654.51 555.7 649.92 553.47 643.39 563.27 636.86 546.95 631.86 544.45 618.71 511.56 598.43 541.96 590.96 523.27 575.09 515.34 575.98 513.55 592.53 521.83 598.88 537.69 619.15 507.29 633.44 543 638.43 545.5 643.83 559 649.22 550.91 653.81 553.14 661.56 541.51 669.68 561.81 685.55 569.75 684.66 571.54"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "748.71 722.7 992.23 600.91 992.23 357.37 748.71 479.15 748.71 722.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "748.71 479.18 505.19 357.39 748.71 235.61 992.23 357.39 748.71 479.18"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "992.23 844.48 748.71 722.7 748.71 479.15 992.23 600.94 992.23 844.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "992.23 844.48 1235.74 722.7 1235.74 479.15 992.23 600.94 992.23 844.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M1085.58,732.08c-5.85,2.92-10.58,10.03-10.58,15.88s4.74,8.21,10.58,5.29c5.84-2.92,10.58-10.03,10.58-15.88s-4.74-8.21-10.58-5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M1113.98,717.87c-5.85,2.92-10.58,10.03-10.58,15.88s4.74,8.21,10.58,5.29c5.85-2.92,10.58-10.03,10.58-15.88s-4.74-8.21-10.58-5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M1142.39,704.25c-5.85,2.92-10.58,10.03-10.58,15.88s4.74,8.21,10.58,5.29c5.85-2.92,10.58-10.03,10.58-15.88s-4.74-8.21-10.58-5.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "992.23 600.96 748.71 479.18 992.23 357.39 1235.74 479.18 992.23 600.96"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M1064.25,723.66l99.47-49.75c4.65-2.32,8.42-7.98,8.42-12.63v-57.1c0-4.65-3.77-6.53-8.42-4.21l-99.47,49.75c-4.65,2.32-8.42,7.98-8.42,12.63v57.1c0,4.65,3.77,6.53,8.42,4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1057.17,720.12l99.47-49.75c4.65-2.32,8.42-7.98,8.42-12.63v-57.1c0-.42-.04-.81-.1-1.19,4.06-1.43,7.18.5,7.18,4.73v57.1c0,4.65-3.77,10.3-8.42,12.63l-99.47,49.75c-4.23,2.11-7.72.74-8.32-3.02.41-.14.82-.31,1.24-.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "1056.28 689.74 1055.39 687.95 1073.48 678.9 1077.81 685.41 1082.15 674.56 1086.3 672.49 1096.4 647.19 1106.92 662.62 1120.85 655.65 1128.76 667.52 1142.26 633.78 1147.84 642.15 1164.35 633.89 1165.24 635.68 1147.16 644.73 1142.7 638.05 1129.2 671.79 1120.16 658.23 1106.25 665.19 1096.87 651.42 1087.87 673.94 1083.73 676.01 1078.26 689.69 1072.79 681.48 1056.28 689.74"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M923.54,721.72c-2.81-1.41-5.09-.27-5.09,2.54v42.3c0,2.81,2.28,6.23,5.09,7.63,2.81,1.41,5.09.27,5.09-2.54v-42.3c0-2.81-2.28-6.23-5.09-7.63ZM893.02,706.45c-2.81-1.41-5.09-.27-5.09,2.54v42.3c0,2.81,2.28,6.23,5.09,7.63,2.81,1.41,5.09.27,5.09-2.54v-42.3c0-2.81-2.28-6.23-5.09-7.63ZM908.28,714.09c-2.81-1.4-5.09-.27-5.09,2.54v42.3c0,2.81,2.28,6.23,5.09,7.63,2.81,1.4,5.09.27,5.09-2.54v-42.3c0-2.81-2.28-6.23-5.09-7.63ZM954.07,736.98c-2.81-1.41-5.09-.27-5.09,2.54v42.3c0,2.81,2.28,6.23,5.09,7.63,2.81,1.41,5.09.27,5.09-2.54v-42.3c0-2.81-2.28-6.23-5.09-7.63ZM938.8,729.35c-2.81-1.41-5.09-.27-5.09,2.54v42.3c0,2.81,2.28,6.23,5.09,7.63,2.81,1.41,5.09.27,5.09-2.54v-42.3c0-2.81-2.28-6.23-5.09-7.63Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M928.83,610.05c0,5.85,4.74,12.95,10.58,15.88,5.85,2.92,10.58.55,10.58-5.29s-4.74-12.95-10.58-15.88-10.58-.55-10.58,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M897.08,594.18c0,5.85,4.74,12.95,10.58,15.88s10.58.55,10.58-5.29-4.74-12.95-10.58-15.88c-5.85-2.92-10.58-.55-10.58,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M928.83,639.39c0,5.85,4.74,12.95,10.58,15.88,5.85,2.92,10.58.55,10.58-5.29s-4.74-12.95-10.58-15.88c-5.85-2.92-10.58-.55-10.58,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M897.08,623.51c0,5.85,4.74,12.95,10.58,15.88,5.85,2.92,10.58.55,10.58-5.29s-4.74-12.95-10.58-15.88c-5.85-2.92-10.58-.55-10.58,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M928.83,668.72c0,5.85,4.74,12.95,10.58,15.88,5.85,2.92,10.58.55,10.58-5.29s-4.74-12.95-10.58-15.88c-5.85-2.92-10.58-.55-10.58,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M897.08,652.84c0,5.85,4.74,12.95,10.58,15.88,5.85,2.92,10.58.55,10.58-5.29s-4.74-12.95-10.58-15.88-10.58-.55-10.58,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M928.83,698.05c0,5.85,4.74,12.95,10.58,15.88,5.85,2.92,10.58.55,10.58-5.29s-4.74-12.95-10.58-15.88c-5.85-2.92-10.58-.55-10.58,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M897.08,682.17c0,5.85,4.74,12.95,10.58,15.88s10.58.55,10.58-5.29-4.74-12.95-10.58-15.88c-5.85-2.92-10.58-.55-10.58,5.29Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1012.86,298.02l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M1018.36,295.27l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1023.87,292.52l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1029.37,289.77l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1034.87,287.02l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1040.37,284.26l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1045.87,281.51l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1051.38,278.76l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1056.88,276.01l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1062.38,273.26l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1067.88,270.51l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M1073.38,267.76l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1078.89,265l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M1084.39,262.25l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1089.89,259.5l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1095.39,256.75l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1100.89,254l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1106.4,251.25l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1111.9,248.49l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M1117.4,245.74l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M1122.9,242.99l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M1128.4,240.24l-112.94,56.48c-12.36,6.18-32.4,6.18-44.77,0l-112.94-56.48c-12.36-6.18-12.36-16.21,0-22.39l112.94-56.48c12.36-6.18,32.4-6.18,44.77,0l112.94,56.48c12.36,6.18,12.36,16.21,0,22.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1128.43,60.94l-112.6-56.31c-12.32-6.16-32.31-6.16-44.63,0l-112.6,56.31c-6.16,3.08-9.24,7.12-9.24,11.16v157.25c0,4.04,3.08,8.08,9.24,11.16l112.6,56.31c12.32,6.16,32.31,6.16,44.63,0l112.6-56.31c6.16-3.08,9.24-7.12,9.24-11.16V72.1c0-4.04-3.08-8.08-9.24-11.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1022.17,161.92c-2.89,1.45-5.24,4.96-5.24,7.85s2.34,4.06,5.24,2.62c2.89-1.45,5.24-4.96,5.24-7.85s-2.34-4.06-5.24-2.62ZM1039.71,153.16c-2.89,1.45-5.24,4.96-5.24,7.85s2.34,4.06,5.24,2.62c2.89-1.45,5.24-4.96,5.24-7.85s-2.34-4.06-5.24-2.62ZM1057.24,144.39c-2.89,1.45-5.24,4.96-5.24,7.85s2.34,4.06,5.24,2.62c2.89-1.45,5.24-4.96,5.24-7.85s-2.34-4.06-5.24-2.62ZM1074.77,135.62c-2.89,1.45-5.24,4.96-5.24,7.85s2.34,4.06,5.24,2.62c2.89-1.45,5.24-4.96,5.24-7.86s-2.34-4.06-5.24-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1128.43,83.26l-112.6,56.31c-12.32,6.16-32.31,6.16-44.63,0l-112.6-56.31c-12.32-6.16-12.32-16.16,0-22.32l112.6-56.31c12.32-6.16,32.31-6.16,44.63,0l112.6,56.31c12.32,6.16,12.32,16.16,0,22.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M1061.9,77.75l-57.08,28.55c-6.25,3.12-16.38,3.12-22.62,0l-57.08-28.55c-6.25-3.12-6.25-8.19,0-11.31l57.08-28.55c6.25-3.12,16.38-3.12,22.62,0l57.08,28.55c6.25,3.12,6.25,8.19,0,11.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M922.97,76.42c.61-.47,1.32-.92,2.15-1.34l57.08-28.55c6.25-3.12,16.38-3.12,22.62,0l57.08,28.55c.83.41,1.54.87,2.15,1.34,3.98-3.1,3.27-7.27-2.15-9.98l-57.08-28.55c-6.25-3.12-16.38-3.12-22.62,0l-57.08,28.55c-5.42,2.71-6.13,6.88-2.15,9.98Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M287.85,439.44l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M293.37,436.68l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M298.89,433.92l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M304.4,431.16l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M309.92,428.4l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M315.44,425.64l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M320.96,422.88l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M326.48,420.12l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M332,417.36l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M337.52,414.6l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M343.03,411.84l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M348.55,409.08l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M354.07,406.32l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M359.59,403.56l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M365.11,400.8l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M370.63,398.04l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M376.15,395.28l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M381.67,392.52l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M387.18,389.76l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M392.7,387l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M398.22,384.24l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M403.74,381.48l-113.28,56.65c-12.4,6.2-32.5,6.2-44.9,0l-113.28-56.65c-12.4-6.2-12.4-16.25,0-22.46l113.28-56.65c12.4-6.2,32.5-6.2,44.9,0l113.28,56.65c12.4,6.2,12.4,16.25,0,22.46Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M384.06,211.14l-108.41-54.22c-8.11-4.06-15.44-4.38-20.7-1.64,0-.01-121.95,61.01-121.95,61.01-.45.2-.89.42-1.31.66-4.89,2.82-7.85,8.25-7.85,15.86v108.41c0,16.01,12.97,35.47,28.98,43.48l108.41,54.22c8.08,4.04,15.38,4.38,20.64,1.67,0,.01,122.02-61.05,122.02-61.05.45-.2.88-.42,1.3-.66,4.87-2.78,7.85-8.22,7.85-15.87v-108.41c0-16.01-12.97-35.47-28.98-43.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M309.12,310.06c-2.9,1.45-5.25,4.98-5.25,7.88s2.35,4.08,5.25,2.63c2.9-1.45,5.25-4.98,5.25-7.88s-2.35-4.08-5.25-2.63ZM326.71,301.26c-2.9,1.45-5.25,4.98-5.25,7.88s2.35,4.08,5.25,2.63c2.9-1.45,5.25-4.98,5.25-7.88s-2.35-4.08-5.25-2.63ZM344.3,292.46c-2.9,1.45-5.25,4.98-5.25,7.88s2.35,4.08,5.25,2.63c2.9-1.45,5.25-4.98,5.25-7.88s-2.35-4.08-5.25-2.63ZM361.88,283.67c-2.9,1.45-5.25,4.98-5.25,7.88s2.35,4.08,5.25,2.63,5.25-4.98,5.25-7.88-2.35-4.08-5.25-2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M261.23,438.92l-108.41-54.22c-16.01-8-28.98-27.47-28.98-43.48v-108.41c0-16.01,12.98-22.49,28.98-14.49l108.41,54.22c16.01,8,28.98,27.47,28.98,43.48v108.41c0,16.01-12.98,22.49-28.98,14.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M239.55,394.8l-65.05-32.53c-9.6-4.8-17.39-16.48-17.39-26.09v-65.05c0-9.6,7.79-13.5,17.39-8.69l65.05,32.53c9.6,4.8,17.39,16.48,17.39,26.09v65.05c0,9.6-7.79,13.5-17.39,8.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M225.01,314.62c0,3.59,2.91,7.95,6.49,9.74,3.59,1.79,6.5.34,6.5-3.25s-2.91-7.95-6.5-9.74c-3.59-1.79-6.49-.34-6.49,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M205.53,304.88c0,3.59,2.91,7.95,6.49,9.74s6.5.34,6.5-3.25-2.91-7.95-6.5-9.74-6.49-.34-6.49,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M186.04,295.13c0,3.59,2.91,7.95,6.5,9.74s6.49.34,6.49-3.25-2.91-7.95-6.49-9.74-6.5-.34-6.5,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M225.01,332.62c0,3.59,2.91,7.95,6.49,9.74,3.59,1.79,6.5.34,6.5-3.25s-2.91-7.95-6.5-9.74c-3.59-1.79-6.49-.34-6.49,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M205.53,322.88c0,3.59,2.91,7.95,6.49,9.74,3.59,1.79,6.5.34,6.5-3.25s-2.91-7.95-6.5-9.74c-3.59-1.79-6.49-.34-6.49,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M186.04,313.14c0,3.59,2.91,7.95,6.5,9.74,3.59,1.79,6.49.34,6.49-3.25s-2.91-7.95-6.49-9.74c-3.59-1.79-6.5-.34-6.5,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M225.01,350.62c0,3.59,2.91,7.95,6.49,9.74,3.59,1.79,6.5.34,6.5-3.25s-2.91-7.95-6.5-9.74c-3.59-1.79-6.49-.34-6.49,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M205.53,340.88c0,3.59,2.91,7.95,6.49,9.74,3.59,1.79,6.5.34,6.5-3.25s-2.91-7.95-6.5-9.74c-3.59-1.79-6.49-.34-6.49,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M186.04,331.14c0,3.59,2.91,7.95,6.5,9.74,3.59,1.79,6.49.34,6.49-3.25s-2.91-7.95-6.49-9.74c-3.59-1.79-6.5-.34-6.5,3.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M248.07,390.54l-65.05-32.53c-9.6-4.8-17.39-16.48-17.39-26.09v-65.05c0-2.6.58-4.76,1.6-6.46-5.97-.23-10.12,3.71-10.12,10.72v65.04c0,9.6,7.79,21.28,17.39,26.09l65.05,32.53c7.01,3.51,13.03,2.36,15.79-2.23-2.21-.09-4.67-.73-7.26-2.03Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "631.55 336.43 776.03 408.69 631.55 480.94 487.08 408.69 631.55 336.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "642.19 331.11 786.66 403.37 642.19 475.62 497.72 403.37 642.19 331.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "652.83 325.8 797.3 398.05 652.83 470.3 508.35 398.05 652.83 325.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "663.46 320.48 807.94 392.73 663.46 464.98 518.99 392.73 663.46 320.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "674.1 315.16 818.58 387.41 674.1 459.66 529.63 387.41 674.1 315.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "684.74 309.84 829.21 382.09 684.74 454.34 540.26 382.09 684.74 309.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "695.38 304.52 839.85 376.77 695.38 449.02 550.9 376.77 695.38 304.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "706.01 299.2 850.49 371.45 706.01 443.7 561.54 371.45 706.01 299.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "716.65 293.88 861.13 366.13 716.65 438.38 572.18 366.13 716.65 293.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "727.29 288.56 871.76 360.81 727.29 433.06 582.81 360.81 727.29 288.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "737.93 283.24 882.4 355.49 737.93 427.74 593.45 355.49 737.93 283.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "748.56 277.92 893.04 350.17 748.56 422.42 604.09 350.17 748.56 277.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "748.71 422.49 604.09 350.17 604.09 205.55 748.71 277.88 748.71 422.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "893.33 350.17 748.71 422.49 748.71 277.88 893.33 205.55 893.33 350.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "893.33 205.55 748.71 277.88 604.09 205.55 748.71 133.22 893.33 205.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "821.02 205.55 748.71 241.71 676.4 205.55 748.71 169.39 821.02 205.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "821.02 205.55 748.71 241.71 748.71 169.39 821.02 205.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M676.4,345.74c-17.49-8.75-31.72-30.09-31.72-47.58s14.23-24.6,31.72-15.86c17.49,8.75,31.72,30.09,31.72,47.59s-14.23,24.6-31.72,15.86ZM676.4,296.94c-9.42-4.71-17.08-.88-17.08,8.54s7.66,20.91,17.08,25.62c9.42,4.71,17.08.88,17.08-8.54s-7.66-20.91-17.08-25.62Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "1118.88 336.43 1263.35 408.69 1118.88 480.94 974.4 408.69 1118.88 336.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "1129.51 331.11 1273.99 403.37 1129.51 475.62 985.04 403.37 1129.51 331.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "1140.15 325.8 1284.63 398.05 1140.15 470.3 995.68 398.05 1140.15 325.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1150.79 320.48 1295.26 392.73 1150.79 464.98 1006.31 392.73 1150.79 320.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "1161.43 315.16 1305.9 387.41 1161.43 459.66 1016.95 387.41 1161.43 315.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "1172.06 309.84 1316.54 382.09 1172.06 454.34 1027.59 382.09 1172.06 309.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "1182.7 304.52 1327.18 376.77 1182.7 449.02 1038.23 376.77 1182.7 304.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "1193.34 299.2 1337.81 371.45 1193.34 443.7 1048.86 371.45 1193.34 299.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "1203.98 293.88 1348.45 366.13 1203.98 438.38 1059.5 366.13 1203.98 293.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "1214.61 288.56 1359.09 360.81 1214.61 433.06 1070.14 360.81 1214.61 288.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "1225.25 283.24 1369.73 355.49 1225.25 427.74 1080.78 355.49 1225.25 283.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "1235.89 277.92 1380.36 350.17 1235.89 422.42 1091.41 350.17 1235.89 277.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "1235.74 422.49 1091.12 350.17 1091.12 205.55 1235.74 277.88 1235.74 422.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "1380.36 350.17 1235.74 422.49 1235.74 277.88 1380.36 205.55 1380.36 350.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M1189.63,319.58c-4.17-2.08-7.55-.4-7.55,3.77s3.38,9.24,7.55,11.32,7.55.4,7.55-3.77-3.38-9.24-7.55-11.32ZM1163.43,306.48c-4.17-2.08-7.55-.4-7.55,3.77s3.38,9.24,7.55,11.32,7.55.4,7.55-3.77-3.38-9.24-7.55-11.32ZM1137.24,293.38c-4.17-2.08-7.55-.4-7.55,3.77s3.38,9.24,7.55,11.32,7.55.4,7.55-3.77-3.38-9.24-7.55-11.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "1380.36 205.55 1235.74 277.88 1091.12 205.55 1235.74 133.22 1380.36 205.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1308.05 205.55 1235.74 241.71 1163.43 205.55 1235.74 169.39 1308.05 205.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "1308.05 205.55 1235.74 241.71 1235.74 169.39 1308.05 205.55"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "144.47 837.9 288.95 910.15 144.47 982.41 0 910.15 144.47 837.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "155.11 832.58 299.59 904.83 155.11 977.09 10.64 904.83 155.11 832.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "165.75 827.26 310.22 899.51 165.75 971.77 21.27 899.51 165.75 827.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "176.39 821.94 320.86 894.19 176.39 966.45 31.91 894.19 176.39 821.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "187.02 816.62 331.5 888.87 187.02 961.13 42.55 888.87 187.02 816.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "197.66 811.3 342.14 883.55 197.66 955.81 53.19 883.55 197.66 811.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "208.3 805.98 352.77 878.23 208.3 950.49 63.82 878.23 208.3 805.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "218.94 800.66 363.41 872.91 218.94 945.17 74.46 872.91 218.94 800.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "229.57 795.34 374.05 867.59 229.57 939.85 85.1 867.59 229.57 795.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "240.21 790.02 384.69 862.27 240.21 934.53 95.74 862.27 240.21 790.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "250.85 784.7 395.32 856.95 250.85 929.21 106.37 856.95 250.85 784.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "261.49 779.38 405.96 851.63 261.49 923.89 117.01 851.63 261.49 779.38"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "319.84 750.42 261.67 779.51 117.39 707.35 261.67 635.19 319.84 664.28 319.84 750.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "405.96 851.63 261.67 923.79 261.67 779.51 319.88 750.4 405.96 793.47 405.96 851.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "261.67 923.79 117.39 851.63 117.39 707.35 261.67 779.51 261.67 923.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "405.96 793.47 319.84 750.4 175.55 822.56 261.67 865.63 405.96 793.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "319.84 664.28 175.55 736.44 175.55 822.56 319.84 750.4 319.84 664.28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "336.21 743.77 310.73 756.51 285.26 743.77 310.73 731.03 336.21 743.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "336.21 769.24 310.73 781.98 310.73 756.51 336.21 743.77 336.21 769.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "310.73 781.98 285.26 769.24 285.26 743.77 310.73 756.51 310.73 781.98"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "405.96 743.77 380.49 756.51 355.01 743.77 380.49 731.03 405.96 743.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "405.96 769.24 380.49 781.98 380.49 756.51 405.96 743.77 405.96 769.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "380.49 781.98 355.01 769.24 355.01 743.77 380.49 756.51 380.49 781.98"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "369.98 761.76 344.51 774.5 319.03 761.76 344.51 749.02 369.98 761.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "369.98 787.24 344.51 799.98 344.51 774.5 369.98 761.76 369.98 787.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "344.51 799.98 319.03 787.24 319.03 761.76 344.51 774.5 344.51 799.98"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "369.98 690.09 344.51 702.83 319.03 690.09 344.51 677.35 369.98 690.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "369.98 715.57 344.51 728.31 344.51 702.83 369.98 690.09 369.98 715.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "344.51 728.31 319.03 715.57 319.03 690.09 344.51 702.83 344.51 728.31"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "336.21 707.94 310.73 720.68 285.26 707.94 310.73 695.2 336.21 707.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "336.21 733.41 310.73 746.15 310.73 720.68 336.21 707.94 336.21 733.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "310.73 746.15 285.26 733.41 285.26 707.94 310.73 720.68 310.73 746.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "405.96 707.94 380.49 720.68 355.01 707.94 380.49 695.2 405.96 707.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "405.96 733.41 380.49 746.15 380.49 720.68 405.96 707.94 405.96 733.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "380.49 746.15 355.01 733.41 355.01 707.94 380.49 720.68 380.49 746.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "369.98 725.93 344.51 738.67 319.03 725.93 344.51 713.19 369.98 725.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "369.98 751.41 344.51 764.15 344.51 738.67 369.98 725.93 369.98 751.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "344.51 764.15 319.03 751.41 319.03 725.93 344.51 738.67 344.51 764.15"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "321.79 749.44 261.67 779.51 201.56 749.44 261.67 719.38 321.79 749.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "321.79 809.56 261.67 839.62 261.67 779.51 321.79 749.44 321.79 809.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "261.67 839.62 201.56 809.56 201.56 749.44 261.67 779.51 261.67 839.62"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1022.32,457.27c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1025.82,455.52c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1029.32,453.77c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M1032.82,452.02c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1036.32,450.27c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1039.81,448.52c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M1043.31,446.77c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M1046.81,445.02c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M1050.31,443.27c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M1053.81,441.52c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1057.31,439.77c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1060.81,438.02c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1064.31,436.27c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M1067.8,434.52c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1071.3,432.77c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M1074.8,431.02c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1078.3,429.27c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1081.8,427.52c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1085.3,425.77c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1088.8,424.02c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M1092.3,422.27c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M1095.79,420.52c57.12,28.57,57.12,74.88,0,103.45-57.12,28.57-149.73,28.57-206.85,0-57.12-28.57-57.12-74.88,0-103.45,57.12-28.57,149.73-28.57,206.85,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1095.75,376.63c-57.18-28.6-149.9-28.6-207.08,0-28.6,14.31-42.9,33.06-42.89,51.81,0,0,0,42.61,0,42.61,0,18.74,14.3,37.48,42.89,51.78,57.18,28.6,149.9,28.6,207.08,0,28.6-14.31,42.9-33.06,42.89-51.8v-42.58c.01-18.75-14.28-37.5-42.89-51.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M888.66,376.63c-57.18,28.6-57.18,74.97,0,103.56,57.18,28.6,149.9,28.6,207.08,0,57.18-28.6,57.18-74.97,0-103.56s-149.9-28.6-207.08,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 845.77,
    y: 408.08,
    width: 147.31,
    height: 75.05
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M1080.04,348.44c-48.03-24.02-125.9-24.02-173.94,0-24.03,12.02-36.03,27.77-36.02,43.51,0,0,0,29.66,0,29.66,0,15.74,12.01,31.48,36.02,43.49,48.03,24.02,125.9,24.02,173.94,0,24.03-12.02,36.03-27.76,36.02-43.51v-29.64c.01-15.75-12-31.5-36.02-43.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M906.11,348.44c-48.03,24.02-48.03,62.97,0,86.99,48.03,24.02,125.9,24.02,173.94,0,48.03-24.02,48.03-62.97,0-86.99-48.03-24.02-125.9-24.02-173.94,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M923.86,357.32c-38.23,19.12-38.23,50.11,0,69.23,38.23,19.12,100.21,19.12,138.44,0,38.23-19.12,38.23-50.11,0-69.23-38.23-19.12-100.21-19.12-138.44,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1080.04,297.94c-48.03-24.02-125.9-24.02-173.94,0-24.03,12.02-36.03,27.77-36.02,43.51,0,0,0,29.66,0,29.66,0,15.74,12.01,31.48,36.02,43.49,48.03,24.02,125.9,24.02,173.94,0,24.03-12.02,36.03-27.76,36.02-43.51v-29.64c.01-15.75-12-31.5-36.02-43.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M906.11,297.94c-48.03,24.02-48.03,62.97,0,86.99,48.03,24.02,125.9,24.02,173.94,0,48.03-24.02,48.03-62.97,0-86.99-48.03-24.02-125.9-24.02-173.94,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M923.86,306.81c-38.23,19.12-38.23,50.11,0,69.23,38.23,19.12,100.21,19.12,138.44,0,38.23-19.12,38.23-50.11,0-69.23s-100.21-19.12-138.44,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M1080.04,247.43c-48.03-24.02-125.9-24.02-173.94,0-24.03,12.02-36.03,27.77-36.02,43.51,0,0,0,29.66,0,29.66,0,15.74,12.01,31.48,36.02,43.49,48.03,24.02,125.9,24.02,173.94,0,24.03-12.02,36.03-27.76,36.02-43.51v-29.64c.01-15.75-12-31.5-36.02-43.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M906.11,247.43c-48.03,24.02-48.03,62.97,0,86.99,48.03,24.02,125.9,24.02,173.94,0,48.03-24.02,48.03-62.97,0-86.99-48.03-24.02-125.9-24.02-173.94,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M923.86,256.31c-38.23,19.12-38.23,50.11,0,69.23,38.23,19.12,100.21,19.12,138.44,0,38.23-19.12,38.23-50.11,0-69.23-38.23-19.12-100.21-19.12-138.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M947.84,268.3c-24.98,12.49-24.98,32.75,0,45.25,24.98,12.49,65.49,12.49,90.47,0,24.98-12.49,24.98-32.75,0-45.25-24.98-12.49-65.49-12.49-90.47,0Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1441.68,965.75c-.3,0-.61-.07-.89-.21l-294.51-147.7c-12.42-6.21-20.18-18.69-20.25-32.58-.06-12.31-6.93-23.41-17.92-28.96l-23.44-11.84c-.99-.5-1.38-1.7-.88-2.69.5-.98,1.7-1.38,2.69-.88l23.44,11.84c12.34,6.23,20.04,18.69,20.11,32.51.06,12.37,6.97,23.49,18.04,29.02l294.51,147.7c.99.5,1.39,1.7.89,2.68-.35.7-1.06,1.1-1.79,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1427.52,930.25c-.3,0-.61-.07-.89-.21l-251.94-126.42c-12.42-6.21-20.18-18.69-20.25-32.58-.06-12.31-6.93-23.41-17.92-28.96l-23.44-11.84c-.99-.5-1.38-1.7-.88-2.69.5-.98,1.7-1.38,2.69-.88l23.44,11.84c12.34,6.23,20.04,18.69,20.11,32.51.06,12.37,6.98,23.49,18.04,29.02l251.95,126.42c.99.5,1.39,1.7.89,2.68-.35.7-1.06,1.1-1.79,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1413.37,894.76c-.3,0-.61-.07-.9-.21l-209.38-105.13c-12.42-6.21-20.17-18.69-20.25-32.58-.06-12.31-6.93-23.41-17.92-28.96l-23.44-11.84c-.99-.5-1.38-1.7-.88-2.69.5-.98,1.7-1.38,2.69-.88l23.44,11.84c12.34,6.23,20.04,18.69,20.11,32.51.06,12.37,6.98,23.49,18.04,29.02l209.38,105.13c.99.5,1.39,1.7.89,2.68-.35.7-1.06,1.1-1.79,1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "1205.77 1018.71 1387.61 1109.65 1360.38 1123.27 1178.54 1032.33 1205.77 1018.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "1213.83 1014.68 1395.66 1105.62 1368.44 1119.24 1186.6 1028.3 1213.83 1014.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "1221.88 1010.65 1403.72 1101.59 1376.49 1115.21 1194.66 1024.27 1221.88 1010.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1229.94 1006.62 1411.78 1097.56 1384.55 1111.18 1202.71 1020.24 1229.94 1006.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1238 1002.59 1419.84 1093.53 1392.61 1107.15 1210.77 1016.21 1238 1002.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "1246.06 998.57 1427.89 1089.5 1400.67 1103.12 1218.83 1012.18 1246.06 998.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "1254.11 994.54 1435.95 1085.47 1408.72 1099.09 1226.88 1008.15 1254.11 994.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "1262.17 990.51 1444.01 1081.44 1416.78 1095.06 1234.94 1004.12 1262.17 990.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "1270.23 986.48 1452.07 1077.41 1424.84 1091.03 1243 1000.09 1270.23 986.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "1278.29 982.45 1460.12 1073.39 1432.89 1087 1251.06 996.06 1278.29 982.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "1286.34 978.42 1468.18 1069.36 1440.95 1082.97 1259.11 992.03 1286.34 978.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "1294.4 974.39 1476.24 1065.33 1449.01 1078.94 1267.17 988.01 1294.4 974.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "1302.46 970.36 1484.3 1061.3 1457.07 1074.91 1275.23 983.98 1302.46 970.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "1310.52 966.33 1492.35 1057.27 1465.12 1070.88 1283.29 979.95 1310.52 966.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "1318.57 962.3 1500.41 1053.24 1473.18 1066.86 1291.34 975.92 1318.57 962.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1326.63 958.27 1508.47 1049.21 1481.24 1062.83 1299.4 971.89 1326.63 958.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "1334.69 954.24 1516.53 1045.18 1489.3 1058.8 1307.46 967.86 1334.69 954.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "1342.75 950.21 1524.58 1041.15 1497.35 1054.77 1315.52 963.83 1342.75 950.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1350.8 946.18 1532.64 1037.12 1505.41 1050.74 1323.57 959.8 1350.8 946.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "1358.86 942.15 1540.7 1033.09 1513.47 1046.71 1331.63 955.77 1358.86 942.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "1366.92 938.12 1548.76 1029.06 1521.53 1042.68 1339.69 951.74 1366.92 938.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "1374.98 934.09 1556.81 1025.03 1529.58 1038.65 1347.75 947.71 1374.98 934.09"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1573.67,805.22c.68-2.04,284.17-58.6,284.17-58.6v127.87c-75.96,1.7-150.92,17.05-208.93,46.06-58,29.01-88.69,66.5-92.1,104.49h-184.53v-89.21s200.7-128.55,201.39-130.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M1518.5,766.11c-94.01,47.02-142.74,108.1-146.22,169.7h184.53c3.4-37.99,34.09-75.48,92.1-104.49,58-29.01,132.97-44.36,208.93-46.06v-92.29c-123.18,1.74-245.32,26.11-339.34,73.13Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1592.87,731.92l4.67,2.34v23.15c0,5.23,4.25,11.61,9.48,14.22l13.18,6.59v4.67l-25.71,12.86-16.06-10.35-8.87-12.44-2.4-28.19,25.71-12.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1594.49,791.08l-13.18-6.59c-5.23-2.61-9.48-8.99-9.48-14.22v-23.15l-4.67-2.34v23.15c0,7.81,6.35,17.33,14.16,21.23l13.18,6.59,25.71-12.86v-4.67l-25.71,12.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1523.91,698.63l109.17-54.59c1.32-.66,2.51-.72,3.38-.29,0,0,4.45,2.24,4.45,2.24l-3.05,2.61v67.41c0,2.64-2.14,5.85-4.78,7.17l-108.49,54.26.42,2.86-4.46-2.22c-.9-.47-1.41-1.39-1.41-2.69v-69.59c0-2.64,2.14-5.85,4.78-7.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1528.58,780.12l109.17-54.59c2.64-1.32,4.78-4.53,4.78-7.17v-69.59c0-2.64-2.14-3.71-4.78-2.39l-109.17,54.59c-2.64,1.32-4.78,4.53-4.78,7.17v69.59c0,2.64,2.14,3.71,4.78,2.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1637.85 720.8 1637.85 651 1528.48 705.7 1528.48 775.5 1637.85 720.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M1566.47,720.21c5.49-2.75,9.39,2.78,13.69.63,8.13-4.07,11.78-26.09,18.47-29.44,7.74-3.87,9.55,15.64,17.18,15.28l-65.3,32.66c4.68-4.09,10.66-16.48,15.95-19.13Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 1372.28,
    y: 935.82,
    width: 184.53,
    height: 89.21,
    transform: "translate(2929.09 1960.85) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M1704.05,792.13l-38.64-19.32c-1.57-.79-4.11-.79-5.68,0l-89.66,44.84c-1.57.79-1.57,2.06,0,2.84l38.64,19.32c1.57.79,4.11.79,5.68,0l89.66-44.84c1.57-.79,1.57-2.06,0-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1704.05,789.38l-38.64-19.32c-1.57-.79-4.11-.79-5.68,0l-89.66,44.84c-1.57.79-1.57,2.06,0,2.84l38.64,19.32c1.57.79,4.11.79,5.68,0l89.66-44.84c1.57-.79,1.57-2.06,0-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1612.62,817.94l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1638.85,814.96l4.9,2.45,29.05-14.53-4.9-2.45-29.05,14.53ZM1620.67,809.02l-4.9,2.45,12.41,6.21,12.95-6.48-4.9-2.45-8.05,4.03-7.51-3.76ZM1620.13,821.7l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1604.57,821.97l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1605.11,814.19l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1660.39,801.57l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1612.08,825.73l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1652.34,800.7l-4.9,2.45,4.9,2.45,4.9-2.45-4.9-2.45ZM1652.88,797.81l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1597.06,818.21l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1628.72,804.99l-4.9,2.45,4.9,2.45,4.9-2.45-4.9-2.45ZM1636.78,800.97l-4.9,2.45,4.9,2.45,4.9-2.45-4.9-2.45ZM1644.29,804.72l-4.9,2.45,4.9,2.45,4.9-2.45-4.9-2.45ZM1644.83,796.94l-4.9,2.45,4.9,2.45,4.9-2.45-4.9-2.45ZM1618.06,807.71l-4.9-2.45-4.9,2.45,4.9,2.45,4.9-2.45ZM1611.54,833.51l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1622.74,823.01l4.9,2.45,4.9-2.45-4.9-2.45-4.9,2.45ZM1614.69,827.04l4.9,2.45,4.9-2.45-4.9-2.45-4.9,2.45ZM1630.8,818.98l4.9,2.45,4.9-2.45-4.9-2.45-4.9,2.45ZM1626.11,803.68l-4.9-2.45-4.9,2.45,4.9,2.45,4.9-2.45ZM1596.52,826l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1604.03,829.76l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1589.01,822.24l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1642.22,795.63l-4.9-2.45-4.9,2.45,4.9,2.45,4.9-2.45ZM1634.16,799.66l-4.9-2.45-4.9,2.45,4.9,2.45,4.9-2.45ZM1645.37,794.05l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1653.42,790.03l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1668.44,797.54l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1671.06,798.85l4.9,2.45,4.9-2.45-4.9-2.45-4.9,2.45ZM1660.93,793.78l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1668.99,789.76l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1679.11,794.82l4.9,2.45,4.9-2.45-4.9-2.45-4.9,2.45ZM1676.49,793.51l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1661.47,786l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1684.55,789.49l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1687.16,790.8l4.9,2.45,4.9-2.45-4.9-2.45-4.9,2.45ZM1677.04,785.73l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1669.53,781.97l4.9-2.45-4.9-2.45-4.9,2.45,4.9,2.45ZM1595.71,809.48l4.9-2.45-2.45-1.23-4.9,2.45,2.45,1.23ZM1587.65,813.51l4.9-2.45-2.45-1.23-4.9,2.45,2.45,1.23ZM1608.65,803.01l-2.45-1.23-4.9,2.45,2.45,1.23,4.9-2.45ZM1616.71,798.98l-2.45-1.23-4.9,2.45,2.45,1.23,4.9-2.45ZM1579.6,817.54l4.9-2.45-2.45-1.23-4.9,2.45,2.45,1.23ZM1632.81,790.93l-2.45-1.23-4.9,2.45,2.45,1.23,4.9-2.45ZM1624.76,794.95l-2.45-1.23-4.9,2.45,2.45,1.23,4.9-2.45ZM1635.97,789.35l4.9-2.45-2.45-1.23-4.9,2.45,2.45,1.23ZM1644.02,785.32l4.9-2.45-2.45-1.23-4.9,2.45,2.45,1.23ZM1652.07,781.3l4.9-2.45-2.45-1.23-4.9,2.45,2.45,1.23ZM1660.12,777.27l4.9-2.45-2.45-1.23-4.9,2.45,2.45,1.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1851.56,1039.32l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M1854.02,1038.09l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1856.48,1036.86l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1858.94,1035.63l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.04,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1861.4,1034.4l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1863.86,1033.17l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1866.32,1031.94l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1868.79,1030.71l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1871.25,1029.48l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1873.71,1028.25l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1876.17,1027.02l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M1878.63,1025.78l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1881.09,1024.55l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M1883.55,1023.32l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1886.01,1022.09l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1888.47,1020.86l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1890.93,1019.63l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1893.39,1018.4l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1895.85,1017.17l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M1898.32,1015.94l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M1900.78,1014.71l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M1903.24,1013.48l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1611.41,944.14v58.2c0,4.01,3.06,8.02,9.18,11.08l119.16,59.59c12.24,6.12,32.08,6.12,44.32,0l119.16-59.59c6.12-3.06,9.18-7.07,9.18-11.08v-58.2h-301.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1611.41,944.14v58.2c0,4.01,3.06,8.02,9.18,11.08l119.16,59.59c6.12,3.06,14.14,4.59,22.16,4.59v-133.47h-150.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M1903.24,955.22l-119.16,59.6c-12.24,6.12-32.08,6.12-44.32,0l-119.16-59.6c-12.24-6.12-12.24-16.05,0-22.17l119.16-59.6c12.24-6.12,32.08-6.12,44.32,0l119.16,59.6c12.24,6.12,12.24,16.05,0,22.17Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1691.02,794.15l-4.41-4.9c-.81-.89-1.85-1.55-3-1.89l-5.59-1.64c-1.05-.31-2.16-.35-3.23-.11l-4.9,1.08c-.7.16-1.22.76-1.27,1.48-.04.63.28,1.22.82,1.53l6.34,3.58-2.35-.34c-.69-.1-1.35.36-1.5,1.05-.14.65.22,1.29.84,1.5l9.49,3.04,1.35,1.14c.54.46,1.31.52,1.91.14l5.15-3.2c.86-.54,1.03-1.72.35-2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1723.6,823.75c-14.51,0-29.17-6.1-39.05-16.65-3.4-3.63-3.21-9.32.41-12.72,3.63-3.4,9.32-3.21,12.72.41,6.38,6.81,18.53,12.7,31.31,10.5,12.94-2.22,23.62-12.16,30.9-28.75,2-4.55,7.31-6.62,11.86-4.62,4.55,2,6.62,7.31,4.62,11.86-12.42,28.3-30.97,36.97-44.35,39.26-2.78.48-5.6.71-8.43.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1658.41,1021.8c-9.04.69-26.8.21-34.14-1.69-7.65-1.98-7.53-8.98-.89-11.21l38.67-11.33,2.49,13.57c.91,4.85-.3,10.2-6.13,10.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1653.56,1010.7c-.06,0-.12,0-.18,0-8.84-.09-15.92-7.34-15.83-16.17l1.04-97.18c.09-8.77,7.23-15.83,16-15.83h57.96c8.84,0,16,7.16,16,16s-7.16,16-16,16h-42.13l-.87,81.35c-.09,8.78-7.24,15.83-16,15.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1770.98,841.28l-60.12,26.24c-.93,14.95-1.38,25.42-.63,43.95,44.57,0,63-1.25,63-24,0-15.95-2.25-28.01-2.25-46.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1770.98,855.73c0-14.03,5.35-62.67,3.61-73.66-.37-2.32-2.16-4.12-4.47-4.5-10.85-1.76-45.73,4.95-53.95,17.11-3.77,14.17-5.3,58.33-5.3,73.29,22.68,4.3,60.12-2.51,60.12-12.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1631.94,811.91c-.38.59-.24,1.39.32,1.81l3.4,2.55-3.94-.52c-.43-.06-.87,0-1.27.17l-5.41,2.28c-.66.28-1.17.84-1.38,1.53l-1.35,4.39c-.34,1.09.13,2.27,1.13,2.84.4.23.86.34,1.33.31l8.02-.41,8.83,1.61c1.76.29,3.42-.94,3.71-2.74l.55-3.49.15-.95c.38-2.43-.57-4.06-3.44-5.39l-8.97-4.46c-.59-.29-1.3-.09-1.66.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1678.56,847c-12.79,0-25.7-4.58-35.27-12.94-3.74-3.27-4.12-8.96-.85-12.7,3.27-3.74,8.96-4.12,12.7-.85,7.02,6.14,19.7,10.79,32.2,7.34,12.65-3.49,22.3-14.45,27.89-31.69,1.54-4.73,6.61-7.32,11.34-5.78,4.73,1.54,7.32,6.61,5.78,11.34-9.54,29.39-27.14,39.87-40.22,43.48-4.4,1.21-8.97,1.8-13.56,1.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1728.3,765.49c.9,7.89,11.47.85,12.53-.19,3.38-3.32,9.05-14.25.7-18.47-2.77-1.4-8.8-1.34-11.02.76-3.23,3.05-2.79,13.03-2.21,17.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1731.46 769.16 1745.87 754 1747.5 779.61 1736.19 782.69 1736.27 770.92 1731.46 769.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M1730.7,723.48c12.69,0,20.65,9.16,32.27,20.52,8.87,8.67.61,15.22,14.64,22.24,14.69,7.35,8.74,28.06,19.03,30.72,8.75,2.26,12.55,12.77,7.03,19.92-22.98,29.75-76.71,6.73-59.62-36.91-4.86-10.49-9.07-21.05-5.37-29.03-24.67-9.05-18.11-27.46-7.97-27.46Z"
  })))))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchain);
export default __webpack_public_path__ + "static/media/blockchain.e4dc1416c04de962cef0d3a0b0c3f6f0.svg";
export { ForwardRef as ReactComponent };